export default "__VITE_ASSET__Bp_N0Drf__"